import { useTranslation } from 'react-i18next';

export function EmptyTextBlock() {
    const { t } = useTranslation();

    return (
        <div className="position-relative">
            <div className="edit-area-block edit-area-block-type-text d-flex align-items-start read-only">
                <div className="edit-area-block-content">
                    <div className="tiny-mce-content-body p-4">
                        <div className="newTextBlockPlaceholder">
                            {t('documents:document.navbar.main.editor.left.blocks.types.emptyTextBlock.text')}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
